import { Actions, ActionTypes } from "./actions";
import { getInitialState, State } from "./state";

const initialState = getInitialState();

const reducer = (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case ActionTypes.fetch:
      return {
        ...state,
        fetchStatus: "loading",
        error: undefined,
        /* start - flights_alternative_fares_for_sold_out_errors_web */
        fetchedAt: undefined
        /* end - flights_alternative_fares_for_sold_out_errors_web */
      };
    case ActionTypes.fetchSuccess:
      return {
        ...state,
        flights: action.payload.flightOffers,
        atolProtectedStatus: action.payload.atolProtectedStatus,
        cabinClassExtension: action.payload.cabinClassExtension,
        subsidizedFaresSummary: action.payload.subsidizedFaresSummary || [],
        availableFilters: action.payload.aggregation,
        baggagePolicies: action.payload.baggagePolicies,
        flightDeals: action.payload.flightDeals,
        fetchStatus: "success",
        error: undefined,
        campaignBanner: action.payload.campaignBanner,
        banners: action.payload.banners,
        searchCriteria: action.payload.searchCriteria,
        searchId: action.payload.searchId,
        displayOptions: action.payload.displayOptions,
        remoteBanners: action.payload.remoteBanners,
        personalisationSegments: action.payload.personalisationSegments,
        /* start -  flights_alternative_fares_for_sold_out_errors_web */
        fetchedAt: new Date().getTime()
        /* end - flights_alternative_fares_for_sold_out_errors_web */
      };

    case ActionTypes.fetchError:
      return {
        ...state,
        fetchStatus: "failed",
        error: action.payload,
        flights: [],
        availableFilters: {}
      };

    case ActionTypes.reset:
      return getInitialState();

    default:
      return state;
  }
};

export { reducer, getInitialState };
